import {StatusType} from '../types/inventory'

interface ProductStatusInput {
  stock: number
  flagNoSales: number
  safetyStock: number
  reorderPoint: number
  currentCoverage: number
  leadTime: number
  targetCoverage: number
}

export function roundStatusDays(value: number): number {
  if (!Number.isFinite(value)) return value
  // Shift decimal digits before rounding to avoid binary multiplication errors
  // such as 10.075 * 100. Apply the sign afterward for Excel's half-away rule.
  const [coefficient, exponent = '0'] = Math.abs(value).toString().split('e')
  const shifted = Number(coefficient + 'e' + (Number(exponent) + 2))
  return Math.sign(value) * Math.round(shifted) / 100
}

export function classifyProductStatus({
  stock, flagNoSales, safetyStock, reorderPoint, currentCoverage, leadTime, targetCoverage,
}: ProductStatusInput): StatusType {
  if (stock === 0) return 'ruptura'
  if (flagNoSales === 1) return 'sem_venda'
  if (stock < safetyStock) return 'iminente'
  if (stock >= safetyStock && stock <= reorderPoint) return 'minimo'
  const coverageDays = roundStatusDays(currentCoverage)
  if (coverageDays < roundStatusDays(leadTime)) return 'critica'
  if (coverageDays > roundStatusDays(targetCoverage)) return 'excesso'
  return 'saudavel'
}
